import React from 'react';
// import { addFilter } from '../../common/services/navigation';
import SearchInput from '../../common/components/_SearchBox';
import PropTypes from 'prop-types';


function CSWIPSchemesFilterFunction({ search, settings }) {
    // let data = d => {
    //     return d.children.map(c => ({ checked: (search.categories && search.categories.toString().split(',').includes(c.key) ? true : false ), label: c.name, value: c.key, children: c.children.map(ch => ({ label:ch.name, value: ch.key})) }));
    // };

    // const onChange = (currentNode, selectedNodes) => {
    //     addFilter(search, 'categories', currentNode.value, currentNode.checked);
    // };
	return (
        <div className="filter-bar">
            <div className="filter__text">
                Filter by
            </div>
            <SearchInput search={search} settings={settings}/>
        </div>
	);
}

CSWIPSchemesFilterFunction.propTypes = {
    search: PropTypes.object,
    settings: PropTypes.object,
    filters: PropTypes.object,
    entries: PropTypes.object,
	options: PropTypes.object,
	title: PropTypes.string
};

export default CSWIPSchemesFilterFunction;
